import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetch, store, update } from "../../../../utils/httpUtil";

export const searchMasterDataWithCriteria = createAsyncThunk(
  "master-data/search",
  async (payload) => {
    try {
      const response = await store("v1/master/search", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const addMasterData = createAsyncThunk("master-data/add", async (payload) => {
  try {
    const response = await store("v1/master", payload);
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
});

export const updateMasterData = createAsyncThunk(
  "master-data/update",
  async (payload) => {
    try {
      const response = await update(`v1/master/${payload?.id}/update`, payload?.payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchMasterDataByID = createAsyncThunk(
  "master-data/detail",
  async (id) => {
    try {
      const response = await fetch(`v1/master/${id}/update-request`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchUpdateRequest = createAsyncThunk(
  "master-data/update-request",
  async (id) => {
    try {
      const response = await fetch(`v1/master/${id}/update-request`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const listPending = ["master-data/search/pending"];
const listFulfilled = ["master-data/search/fulfilled"];
const listRejected = ["master-data/search/rejected"];

const detailPending = [
  "master-data/detail/pending",
  "master-data/add/pending",
  "master-data/update/pending",
  "master-data/update-request/pending",
];
const detailFulfilled = [
  "master-data/detail/fulfilled",
  "master-data/add/fulfilled",
  "master-data/update/fulfilled",
  "master-data/update-request/fulfilled",
];
const detailRejected = [
  "master-data/detail/rejected",
  "master-data/add/rejected",
  "master-data/update/rejected",
  "master-data/update-request/rejected",
];

export const masterSlice = createSlice({
  name: "master",
  initialState: {
    payload: [],
    loading: false,
    errors: {},
    pagination: {},

    detailPayload: [],
    detailLoading: false,
    detailErrors: {},
  },
  reducers: {
    cleanMaster(state) {
      state.payload = [];
      state.loading = false;
      state.errors = {};
      state.pagination = {};
    },
    cleanDetails(state) {
      state.detailPayload = [];
      state.detailLoading = false;
      state.detailErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => listPending.includes(action.type),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => listFulfilled.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.payload = action.payload?.data;
          state.pagination = action.payload?.pagination?.[0];
        }
      )
      .addMatcher(
        (action) => listRejected.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.errors = action.error;
        }
      )
      .addMatcher(
        (action) => detailPending.includes(action.type),
        (state) => {
          state.detailLoading = true;
        }
      )
      .addMatcher(
        (action) => detailFulfilled.includes(action.type),
        (state, action) => {
          state.detailLoading = false;
          state.detailPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => detailRejected.includes(action.type),
        (state, action) => {
          state.detailLoading = false;
          state.detailErrors = action.error;
        }
      );
  },
});

export const { cleanMaster, cleanDetails } = masterSlice.actions;
export default masterSlice;
